export default __webpack_public_path__ + "static/media/Cymer_Award.665a9149.png";